<template>
  <div class="intro">
    <div class="content-summary">
      <div class="summary-left">
        <div class="top">
          <h3 class="title-left">{{ $t('companyIntro') }}</h3>
          <div class="underline title-left"></div>
        </div>
        <div >
          <p class="content" v-html="companyProfile.content"></p>
        </div>
      </div>
      <div class="summary-right">
        <img :src="companyProfile.url" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { getAbout } from "@/api/about.js";
import he from "he";
export default {
  data() {
    return {
      companyProfile: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      getAbout().then((res) => {
        this.companyProfile = res.data;
        console.log(this.about);
        // 转换 HTML 实体
        this.companyProfile.content = he.decode(res.data.content);
      });

    }
  },
};
</script>

<style lang="scss" scoped>
.content-summary {
  //height: 500px;
  display: flex;
  justify-content: space-evenly;
  padding: 80px 0;
  animation: moveUp 0.8s ease-out forwards;

  .summary-left {
    width: 600px;

    .title-left {
      margin-left: 0;
    }
    .content {
      color: #666;
      font-size: 18px;
      // text-indent: 25px;
      line-height: 2;
    }

    .statistics {
      margin-top: 20px;
      text-align: center;
      background-color: #e8f4f6;
      padding: 20px;

      h2 {
        font-size: 18px;
        margin-bottom: 20px;
      }

      .stats-container {
        display: flex;
        justify-content: space-around;

        .stat-item {
          text-align: center;

          .stat-number {
            font-size: 36px;
            font-weight: bold;
            color: #16A085; // 黄色数字
          }

          .unit {
            font-size: 18px;
            font-weight: bold;
            margin-left: 5px;
            color: #000;
          }

          p {
            max-width: 200px;
            margin-top: 10px;
            font-size: 16px;
          }
        }
      }
    }
  }

  .summary-right {
    width: 500px;
    height: 500px;
    margin-top: 100px;
    text-align: center;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: scale(1.05); // 放大效果
      // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3); // 阴影
    }

    img {
      width: 400px;
      height: 300px;
      // margin-top: 20px;
      transition: transform 0.3s ease; // 图片放大效果

      &:hover {
        transform: scale(1.1); // 鼠标悬停图片放大
      }
    }
  }
}

.el-divider-active {
  background-color: #3c6088;
}
</style>